import { Box, Flex, Icon } from "@chakra-ui/react";
import { type CdpVendor } from "lib/sanity";
import Image from "next/image";
import React, { type ComponentProps } from "react";

type VendorVsGraphicProps = {
  firstCdpVendor: CdpVendor;
  secondCdpVendor: CdpVendor;
};

export function VendorVsGraphic({ firstCdpVendor, secondCdpVendor }: VendorVsGraphicProps) {
  return (
    <Box position="relative" width={{ base: "300px", sm: "400px", md: "553px" }} height="auto">
      <Icon width="100%" height="auto" viewBox="0 0 553 308" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="42.25" y="72.75" width="173.5" height="173.5" rx="24.75" stroke="#40E398" strokeWidth="1.5" />
        <rect x="350.25" y="72.75" width="173.5" height="173.5" rx="24.75" stroke="#40E398" strokeWidth="1.5" />
        <path
          d="M542.5 302.011L479.312 302.011C468.17 302.011 457.946 295.836 452.76 285.975L432 246.5"
          stroke="#40E398"
          strokeWidth="1.57707"
        />
        <path
          d="M552.211 302C552.211 299.122 549.878 296.789 547 296.789C544.122 296.789 541.789 299.122 541.789 302C541.789 304.878 544.122 307.211 547 307.211C549.878 307.211 552.211 304.878 552.211 302Z"
          stroke="#40E398"
          strokeWidth="1.57707"
        />
        <path
          d="M10.5 5.98868L73.6882 5.98875C84.8301 5.98876 95.0542 12.1637 100.24 22.0251L121 61.5"
          stroke="#40E398"
          strokeWidth="1.57707"
        />
        <path
          d="M0.788538 6C0.788539 8.87821 3.12179 11.2115 6 11.2115C8.87822 11.2115 11.2115 8.8782 11.2115 6C11.2115 3.12179 8.87821 0.788537 6 0.788538C3.12179 0.788539 0.788537 3.12179 0.788538 6Z"
          stroke="#40E398"
          strokeWidth="1.57707"
        />
        <line x1="216" y1="147.75" x2="245" y2="147.75" stroke="#40E398" strokeWidth="1.5" />
        <line x1="310" y1="147.75" x2="339" y2="147.75" stroke="#40E398" strokeWidth="1.5" />
        <circle cx="277" cy="147.5" r="32.25" stroke="#40E398" strokeWidth="1.5" />
        <circle cx="277" cy="147.5" r="24" fill="#191A1C" />
        <path
          d="M283.89 154.889C282.551 154.889 281.426 154.657 280.517 154.194C279.607 153.714 278.888 153.011 278.358 152.085L280.74 150.795C281.467 151.986 282.559 152.581 284.014 152.581C284.792 152.581 285.371 152.424 285.751 152.11C286.148 151.779 286.346 151.399 286.346 150.969C286.346 150.721 286.255 150.514 286.073 150.349C285.908 150.183 285.685 150.043 285.404 149.927C285.122 149.811 284.792 149.712 284.411 149.629C284.047 149.547 283.667 149.464 283.27 149.381C282.741 149.282 282.212 149.158 281.682 149.009C281.17 148.844 280.707 148.629 280.293 148.364C279.896 148.083 279.566 147.736 279.301 147.322C279.053 146.892 278.929 146.355 278.929 145.71C278.929 145.214 279.036 144.742 279.251 144.296C279.483 143.849 279.805 143.452 280.219 143.105C280.649 142.758 281.162 142.485 281.757 142.286C282.352 142.071 283.022 141.964 283.766 141.964C284.974 141.964 285.982 142.179 286.793 142.609C287.62 143.022 288.298 143.609 288.827 144.37L286.594 145.586C286.297 145.139 285.916 144.792 285.453 144.544C284.99 144.296 284.428 144.172 283.766 144.172C283.022 144.172 282.476 144.321 282.129 144.618C281.782 144.899 281.608 145.247 281.608 145.66C281.608 146.107 281.864 146.421 282.377 146.603C282.89 146.768 283.617 146.958 284.56 147.173C285.073 147.289 285.594 147.43 286.123 147.595C286.652 147.744 287.132 147.959 287.562 148.24C287.992 148.521 288.339 148.877 288.604 149.307C288.868 149.737 289.001 150.274 289.001 150.919C289.001 151.382 288.893 151.854 288.678 152.333C288.48 152.796 288.166 153.226 287.736 153.623C287.322 154.004 286.793 154.31 286.148 154.541C285.503 154.773 284.75 154.889 283.89 154.889Z"
          fill="white"
        />
        <path
          d="M264.834 142.237H267.638L270.937 151.192L274.187 142.237H276.94L272.252 154.641H269.597L264.834 142.237Z"
          fill="white"
        />
      </Icon>

      <VendorLogo
        vendor={firstCdpVendor}
        left={{ base: "16.3px", sm: "21.7px", md: "30px" }}
        top={{ base: "32.8px", sm: "43.7px", md: "60.5px" }}
      />

      <VendorLogo
        vendor={secondCdpVendor}
        left={{ base: "184px", sm: "245.2px", md: "339px" }}
        top={{ base: "32.8px", sm: "43.7px", md: "60.5px" }}
      />
    </Box>
  );
}

function VendorLogo({ vendor, ...props }: { vendor: CdpVendor } & ComponentProps<typeof Flex>) {
  return (
    <Flex
      position="absolute"
      left={{ base: "184px", sm: "245.2px", md: "339px" }}
      top={{ base: "32.8px", sm: "43.7px", md: "60.5px" }}
      w={{ base: "95px", sm: "126.5px", md: "175px" }}
      h={{ base: "95px", sm: "126.5px", md: "175px" }}
      backgroundColor={vendor.lightVariantLogoUrl ? "new.gray.950" : "white"}
      borderRadius={{ base: "12px", sm: "16px", md: "20px" }}
      boxShadow="0px 3.55201px 21.3121px rgba(0, 0, 0, 0.08)"
      justifyContent="center"
      alignItems="center"
      px={{ base: "5", sm: "7", md: "10" }}
      py={{ base: "3", sm: "5", md: "8" }}
      {...props}
    >
      <Box pos="relative" boxSize="100%">
        <Image
          fill
          priority
          sizes="100%"
          src={`${vendor.lightVariantLogoUrl ?? vendor.logoUrl}?w=256`}
          alt={`${vendor.name}.`}
          style={{ objectFit: "contain", maxWidth: "100%", maxHeight: "100%" }}
        />
      </Box>
    </Flex>
  );
}
